import React from 'react';
import './AgreementLanding.css';
import './GuidePage.css';
import usePageAnchor from './usePageAnchor';

const guides = [
  { path: '/help', title: 'Getting started', description: 'How to create and review an agreement.' },
  { path: '/examples', title: 'Example agreements', description: 'Contract terms for different types of agreements.' },
  { path: '/incentives', title: 'Escrow & incentives', description: 'Arbitration, reputation, and security deposits.' },
  { path: '/faq', title: 'Frequently asked questions', description: 'Wallets, transactions, and account access.' }
];

export default function GuidePage({ page, eyebrow, title, intro, sections, hash, children }) {
  usePageAnchor(hash);
  return (
    <main className="agreementHome guidePage">
      <header className="agreementHero">
        <div className="agreementHomeInner guideHeroLayout">
          <div>
            <div className="agreementEyebrow guideBreadcrumb">
              <a href="/help">Help</a><span aria-hidden="true"> / </span>{eyebrow}
            </div>
            <h1>{title}</h1>
            {intro && <p className="agreementIntro">{intro}</p>}
          </div>
          <nav className="guideContents" aria-label="On this page">
            <div className="agreementEyebrow">On this page</div>
            {sections.map(({ id, label }, index) => (
              <a key={id} href={'#' + id}>
                <span aria-hidden="true">{String(index + 1).padStart(2, '0')}</span>{label}
              </a>
            ))}
          </nav>
        </div>
      </header>
      {children}
      <section className="guideRelated" aria-labelledby="related-guides-title">
        <div className="agreementHomeInner">
          <h2 id="related-guides-title">Related guides</h2>
          <div className="guideRelatedLinks">
            {guides.filter(guide => guide.path !== page).map(guide => (
              <a className="guideResource" key={guide.path} href={guide.path}>
                <div><h3>{guide.title}</h3><p>{guide.description}</p></div>
                <span aria-hidden="true">↗</span>
              </a>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
